import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { Car, Eye, X, MapPin } from 'lucide-react';

const ParkingPhotoButton = ({ parking }) => {
  const [showPhoto, setShowPhoto] = useState(false);

  if (!parking?.photo) {
    return null;
  }

  return (
    <>
      {/* Bouton pour afficher la photo du parking */}
      <Button 
        onClick={() => setShowPhoto(true)}
        variant="outline"
        className="flex-1 border-blue-200 text-blue-700 hover:bg-blue-50"
      >
        <Car className="w-5 h-5 mr-2" />
        Voir l'emplacement parking
        <Eye className="w-4 h-4 ml-2" />
      </Button>

      {/* Modal/Card photo parking */}
      {showPhoto && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <Card className="max-w-2xl w-full max-h-[90vh] bg-white">
            <CardContent className="p-0">
              {/* Header avec bouton fermer */}
              <div className="flex items-center justify-between p-4 border-b">
                <h3 className="text-lg font-semibold text-blue-800 flex items-center">
                  <Car className="w-5 h-5 mr-2" />
                  {parking.name || 'Zone de Stationnement'}
                </h3>
                <Button 
                  variant="ghost" 
                  size="sm"
                  onClick={() => setShowPhoto(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X className="w-5 h-5" />
                </Button>
              </div>
              
              {/* Image du parking */}
              <div className="p-4">
                <div className="rounded-lg overflow-hidden shadow-sm mb-4">
                  <img 
                    src={parking.photo} 
                    alt="" // Volontairement vide pour éviter le référencement SEO
                    className="w-full h-64 sm:h-80 object-cover"
                    loading="lazy"
                  />
                </div>
                
                {/* Informations du parking */}
                <div className="space-y-3 text-sm">
                  {parking.description && (
                    <p className="text-blue-700">
                      {parking.description}
                    </p>
                  )}
                  
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {parking.capacity && (
                      <div className="flex items-center text-blue-600">
                        <MapPin className="w-4 h-4 mr-2 flex-shrink-0" />
                        <span><strong>Capacité:</strong> {parking.capacity}</span>
                      </div>
                    )}
                    
                    {parking.price && (
                      <div className="text-blue-600">
                        <strong>Tarif:</strong> {parking.price}
                      </div>
                    )}
                  </div>
                  
                  {parking.access && (
                    <div className="text-blue-600 pt-2">
                      <strong>Accès:</strong> {parking.access}
                    </div>
                  )}
                </div>
              </div>
              
              {/* Footer avec bouton fermer */}
              <div className="p-4 border-t bg-gray-50 text-center">
                <Button 
                  onClick={() => setShowPhoto(false)}
                  variant="outline"
                  className="w-full sm:w-auto"
                >
                  Fermer
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
    </>
  );
};

export default ParkingPhotoButton;